// extracted by mini-css-extract-plugin
export default {"clickable":"styles_clickable__KWvxl","body":"styles_body__lmWqV"};